import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconNotificatons } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../../base/dialog/actions';
import NotificationsDialog from '../../../base/notificationsDialog/NotificationsDialog';
/**
 * Implementation of a button for toggling fullscreen state.
 */
class NotificationsButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.notifications';
        this.label = 'toolbar.notifications';
        this.tooltip = 'toolbar.notifications';
        this.icon = IconNotificatons;
    }
    /**
    * Handles clicking the button, and toggles fullscreen.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { dispatch } = this.props;
        // sendAnalytics(createToolbarEvent(
        //     'toggle.fullscreen',
        //     {
        //         enable: !_fullScreen
        //     }));
        // dispatch(closeOverflowMenuIfOpen());
        // dispatch(setFullScreen(!_fullScreen));
        dispatch(openDialog(NotificationsDialog));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
const mapStateToProps = (state) => {
    return {
    // _fullScreen: state['features/toolbox'].fullScreen,
    // visible: !isIosMobileBrowser()
    };
};
export default translate(connect(mapStateToProps)(NotificationsButton));
